<billing-summary *ngIf="showPaidFullSidebar$" [visible]="showPaidFullSidebar$" [planSummarydata]="planSummary$"  
   (closeSidePopup)="CloseBillingSummary($event)">
</billing-summary>

<payment-summary *ngIf="showPaymentStatusSidebar$" [visible]="showPaymentStatusSidebar$" [uuid]="uuid"
  (hidePaymentSummaryPopup)="HidePaymentSummary($event)">
</payment-summary>